<div class="meal-plan-panels">
    <div class="row g-3">
        <!-- Challenges -->
        <div class="col-md-6">
            <div class="feedback-panel feedback-panel--challenges">
                <h6 class="fw-semibold mb-3">This Week's Challenges</h6>
                <p class="mb-2 text-muted">Loved one has struggled with</p>
                <div class="text-body" [ngSwitch]="challengesView.state">
                    <ng-container *ngSwitchCase="'v2Items'">
                        <div class="meal-plan-item" *ngFor="let item of challengesView.items; trackBy: trackByIndex">
                            <div class="meal-plan-item__label">
                                <i class="bi bi-exclamation-triangle-fill text-warning me-2"></i>{{ item.label }}
                            </div>
                            <div class="meal-plan-item__note" *ngIf="item.note">{{ item.note }}</div>
                        </div>
                        <div class="meal-plan-something-else" *ngIf="challengesView.somethingElse">
                            <i class="bi bi-plus-circle-fill text-warning me-2"></i>{{ challengesView.somethingElse }}
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'legacyItems'">
                        <div *ngFor="let label of challengesView.legacyLabels; trackBy: trackByIndex">
                            <i class="bi bi-exclamation-triangle-fill text-warning me-2"></i>{{ label }}
                        </div>
                    </ng-container>
                    <cdss-weekly-state-label
                        *ngSwitchCase="'nothingThisWeek'"
                        state="nothingToReport"
                        text="Nothing this week">
                    </cdss-weekly-state-label>
                    <cdss-weekly-state-label
                        *ngSwitchCase="'noAnswer'"
                        state="noCheckIn"
                        text="Nothing this week">
                    </cdss-weekly-state-label>
                </div>
            </div>
        </div>

        <!-- Wins -->
        <div class="col-md-6">
            <div class="feedback-panel feedback-panel--wins">
                <h6 class="fw-semibold mb-3">This Week's Wins</h6>
                <p class="mb-2 text-muted">Loved one has</p>
                <div class="text-body" [ngSwitch]="winsView.state">
                    <ng-container *ngSwitchCase="'v2Items'">
                        <div class="meal-plan-item" *ngFor="let item of winsView.items; trackBy: trackByIndex">
                            <div class="meal-plan-item__label">
                                <i class="bi bi-check-circle-fill text-green me-2"></i>{{ item.label }}
                            </div>
                            <div class="meal-plan-item__note" *ngIf="item.note">{{ item.note }}</div>
                        </div>
                        <div class="meal-plan-something-else" *ngIf="winsView.somethingElse">
                            <i class="bi bi-plus-circle-fill text-green me-2"></i>{{ winsView.somethingElse }}
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'legacyItems'">
                        <div *ngFor="let label of winsView.legacyLabels; trackBy: trackByIndex">
                            <i class="bi bi-check-circle-fill text-green me-2"></i>{{ label }}
                        </div>
                    </ng-container>
                    <cdss-weekly-state-label
                        *ngSwitchCase="'nothingThisWeek'"
                        state="nothingToReport"
                        text="Nothing this week">
                    </cdss-weekly-state-label>
                    <cdss-weekly-state-label
                        *ngSwitchCase="'noAnswer'"
                        state="noCheckIn"
                        text="Nothing this week">
                    </cdss-weekly-state-label>
                </div>
            </div>
        </div>
    </div>
</div>
